export const OE_PROSPECT = 'Prospect'
export const OE_CLIENT = 'Client'



// WEBPACK FOOTER //
// ./src/utils/Client/userTypes.js